import React from "react";
import LegalLayout, { Section } from "@/pages/LegalLayout";
import { useLanguage } from "@/context/LanguageContext";

const Refund = () => {
  const { lang } = useLanguage();
  return (
    <LegalLayout
      testId="refund-page"
      eyebrow={lang === "ta" ? "சட்டம்" : "Legal"}
      title={lang === "ta" ? "திரும்பப் பெறும் கொள்கை" : "Refund Policy"}
    >
      <p>
        {lang === "ta"
          ? "TNPSC தமிழ் செயலியில் நீங்கள் வாங்கும் சந்தாக்கள் தொடர்பான திரும்பப் பெறும் (refund) நிபந்தனைகளை இந்த கொள்கை விளக்குகிறது."
          : "This policy explains the refund terms that apply to subscriptions purchased through the TNPSC Tamil app."}
      </p>

      <Section title={lang === "ta" ? "1. 7-நாள் இலவச முயற்சி" : "1. 7-day free trial"}>
        <p>
          {lang === "ta"
            ? "ஒவ்வொரு புதிய பயனருக்கும் அவர் தேர்ந்தெடுக்கும் எந்த Vetri Guide திட்டத்திலும் 7-நாள் இலவச முயற்சி வழங்கப்படுகிறது. முயற்சி காலத்திற்குள் ரத்து செய்தால், எந்த கட்டணமும் வசூலிக்கப்படாது."
            : "Every new user gets a 7-day free trial on any Vetri Guide plan they choose. If you cancel within the trial period, you will not be charged."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "2. மாதாந்திர சந்தா" : "2. Monthly subscription"}>
        <p>
          {lang === "ta"
            ? "மாதாந்திர சந்தா கட்டணம் முன்கூட்டியே செலுத்தப்படும். ஒரு கட்டண காலத்தின் (மாதம்) நடுவில் ரத்து செய்தால், செலுத்திய தொகைக்கு பகுதி திரும்பப் பெறுதல் (pro-rata refund) வழங்கப்பட மாட்டாது — ஆனால் உங்கள் சேவை அந்த காலத்தின் முடிவு வரை செயலில் இருக்கும்."
            : "Monthly subscriptions are billed in advance. If you cancel mid-cycle, we do not offer a pro-rata refund for the remaining days — however, your access continues until the end of that billing period."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "3. தொழில்நுட்ப பிழைகள்" : "3. Technical issues"}>
        <p>
          {lang === "ta"
            ? "எங்கள் சேவை வழங்க முடியாத கடுமையான தொழில்நுட்ப பிழை ஏற்பட்டால் (எ.கா., நீடித்த சேவை செயலிழப்பு), நாங்கள் உங்கள் அடுத்த கட்டண காலத்தில் கடன் (credit) வழங்கலாம் அல்லது அந்தந்த மாதத்திற்கு திரும்பப் பெறுதல் வழங்கலாம். tnpsctamilapp@gmail.com க்கு எழுதி கோரிக்கையை சமர்ப்பிக்கவும்."
            : "If we cannot deliver our service due to a major technical issue (e.g., prolonged outage), we may credit your next billing cycle or issue a refund for the affected month. Submit a request to tnpsctamilapp@gmail.com."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "4. தவறான கட்டணம்" : "4. Wrong charges"}>
        <p>
          {lang === "ta"
            ? "உங்கள் கட்டண அறிக்கையில் தவறான கட்டணம் இருந்தால், கட்டண தேதியிலிருந்து 7 நாட்களுக்குள் எங்களைத் தொடர்பு கொள்ளுங்கள். பரிசோதனை செய்து, தவறு உறுதியானால், முழுத் திரும்பப் பெறுதலை வழங்குவோம்."
            : "If you spot an incorrect charge on your statement, contact us within 7 days of the charge. We'll investigate and issue a full refund if the charge is confirmed to be incorrect."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "5. திரும்பப் பெறும் முறை" : "5. Refund method"}>
        <p>
          {lang === "ta"
            ? "ஒப்புதலுக்குப் பிறகு, திரும்பப் பெறும் தொகை 7–10 வேலை நாட்களுக்குள் அசல் கட்டண முறை (UPI, கார்டு, வாலட்) க்கு திருப்பித் தரப்படும்."
            : "Once approved, refunds are processed back to the original payment method (UPI, card, wallet) within 7–10 business days."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "6. திரும்பப் பெற இயலாதவை" : "6. Non-refundable items"}>
        <p>
          {lang === "ta"
            ? "(a) முடிந்த ஒரு கட்டண காலம் (b) Play Store / App Store கட்டண முறையால் வழங்கப்பட்ட சந்தாக்கள் — அவற்றுக்கான திரும்பப் பெறுதல்கள் Google Play கொள்கையின் கீழ் இயங்கும்."
            : "(a) A completed billing cycle. (b) Subscriptions purchased via the Play Store / App Store — those refunds are governed by Google Play policy."}
        </p>
      </Section>

      <Section title={lang === "ta" ? "7. திரும்பப் பெற கோர" : "7. Request a refund"}>
        <p>
          {lang === "ta" ? "திரும்பப் பெறும் கோரிக்கைகளை " : "Submit refund requests to "}
          <a
            href="mailto:tnpsctamilapp@gmail.com"
            className="text-blue-900 font-semibold underline decoration-amber-400 underline-offset-4"
          >
            tnpsctamilapp@gmail.com
          </a>{" "}
          {lang === "ta"
            ? "மின்னஞ்சலுக்கு பதிவு செய்த பெயர், மின்னஞ்சல், கட்டண தேதி மற்றும் காரணத்துடன் அனுப்புங்கள்."
            : "with your registered name, email, payment date, and reason."}
        </p>
      </Section>
    </LegalLayout>
  );
};

export default Refund;
